import { render } from "./singlepageprofile.vue?vue&type=template&id=44dd37b4"
import script from "./singlepageprofile.vue?vue&type=script&lang=js"
export * from "./singlepageprofile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__